import { z } from "zod";

export const zLayoutMetadataValues = z.object({
    publishAt: z.string().nullable().optional().default(null),
    name: z.string().min(4),
});

export type LayoutMetadata = z.infer<typeof zLayoutMetadataValues>;
